var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myApp"},[_c('a',{on:{"click":_vm.aaa}},[_vm._v("打开我的定位页面")])])
}
var staticRenderFns = []

export { render, staticRenderFns }